module.exports = __webpack_public_path__ + "static/img/img-1.cd1a7cd0.png";